const accessTopic = {
    TOPIC_LIST: { name: 'Test Papers', path: '/test-paper-list' },
    ADD_TOPIC: { name: 'Add Test Paper', path: '/create-test-paper' },
    UPDATE_TOPIC: { name: 'Update Test Paper', path: '/edit-test-paper' },
    DELETE_TOPIC: { name: 'Delete Test Paper', path: '/delete-test-paper' },
    TOPIC_QUESTION_LIST: { name: 'Test Paper Question', path: '/test-paper-question-list' },
    ADD_TOPIC_QUESTION: { name: 'Add Test Paper Question', path: '/add-test-paper-question' },
    DELETE_TOPIC_QUESTION: { name: 'Delete Test Paper Question', path: '/delete-test-paper-question' },
}

export default accessTopic;
